import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Logo from "./Logo.js";
import Modal from "./Modal.js";
import BecomeMember from "./BecomeMember.js";
import CircleIcon from "./CircleIcon.js";
import Pluralize from "react-pluralize";
import "./Header.css";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      showFreeModal: false,
    };
  }

  openCloseFreeModal = bool => {
    this.setState({
      showFreeModal: bool,
    });
  };

  render() {
    if (!this.props.payment) {
      return false;
    }

    const freeRetrosLink = (
      <div
        className="free-outros"
        onClick={() => this.openCloseFreeModal(true)}
      >
        <p>
          {this.props.freeRetros} free{" "}
          <Pluralize
            singular="Outro"
            count={this.props.freeRetros}
            showCount={false}
          />{" "}
          left!
        </p>
      </div>
    );

    return (
      <div>
        <Modal
          showFreeModal={this.state.showFreeModal}
          openCloseFreeModal={this.openCloseFreeModal}
        >
          <BecomeMember
            payment={this.props.payment}
            user={this.props.user}
            openCloseFreeModal={this.openCloseFreeModal}
          />
        </Modal>
        <div className="header-container">
          <div className="mobile-warning">
            <div className="alert-icon">
              <i className="fas fa-2x fa-exclamation" />
            </div>
            <p className="warning-text">
              Heads up! Outro works best on screen sizes bigger than the one
              you're using.
            </p>
          </div>
          <div className="logo">
            <Link to="/">
              <Logo />
            </Link>
          </div>
          <div className="nav-links">
            {this.props.payment.activeSubscription ? null : freeRetrosLink}
            <Link to="/settings" className="settings">
              <CircleIcon type="settings" />
              <p className="text">Settings</p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    uid: PropTypes.string.isRequired,
    creationTime: PropTypes.string.isRequired,
    lastSignInTime: PropTypes.string.isRequired,
    photoURL: PropTypes.string,
  }),
  freeRetros: PropTypes.number.isRequired,
  payment: PropTypes.shape({
    activeSubscription: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    stripeCustomerID: PropTypes.string.isRequired,
  }),
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js